var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStoreAlter = function SvgIconStoreAlter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.229,
    height: 15,
    viewBox: "-5 -2 28 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9540",
    "data-name": "Grupo 9540",
    transform: "translate(-56.77 -28.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9538",
    "data-name": "Grupo 9538",
    transform: "translate(56.77 29.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.941.179a.62.62,0,0,1,.047.8l-.047.061L3.978,4.093a.584.584,0,0,1-.782.049l-.059-.049L.173,1.044a.627.627,0,0,1,0-.866A.578.578,0,0,1,.956.13l.059.049L3.557,2.794,6.1.179A.578.578,0,0,1,6.882.13Z",
    transform: "translate(0 8.477)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6387",
    "data-name": "Caminho 6387",
    d: "M65,45.31V34",
    transform: "translate(-61.442 -33.632)",
    fill: "none",
    stroke: "#191750",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9539",
    "data-name": "Grupo 9539",
    transform: "translate(63.884 28.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M6.941.179a.62.62,0,0,1,.047.8l-.047.061L3.978,4.093a.584.584,0,0,1-.782.049l-.059-.049L.173,1.044a.627.627,0,0,1,0-.866A.578.578,0,0,1,.956.13l.059.049L3.557,2.794,6.1.179A.578.578,0,0,1,6.882.13Z",
    transform: "translate(7.115 4.269) rotate(180)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6388",
    "data-name": "Caminho 6388",
    d: "M65,45.722V34",
    transform: "translate(-61.442 -32.933)",
    fill: "none",
    stroke: "#191750",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStoreAlter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_store_alter.d562fc06.svg";
export { ForwardRef as ReactComponent };